<template>
  <LegacyWrap class="main-space">
    <ExperienceFeed />
  </LegacyWrap>
</template>

<script lang="ts" setup>
import ExperienceFeed from '@/features/ExperienceFeed.vue';
import LegacyWrap from '@/shared/LegacyWrap.vue';
</script>
